import { IAtBy } from "interfaces/at-by";
import { GraphQLData } from "interfaces/graphql-data";
import { IEchoNode } from "interfaces/echo-node";
import { ITenant } from "interfaces/tenant";
import { AtByModel } from "models/at-by-model";
import { TenantModel } from "models/tenant/tenant-model";
import { IEchoEdge } from "interfaces/echo-edge";
import { MessageTypeModel } from "models/message-type/messagetype-model";
import { IMessageType } from "interfaces/message-type";

export class FilesDotComWebhookNodeModel implements IEchoNode, GraphQLData {
  created: IAtBy = new AtByModel('', '');
  deleted: boolean = false;
  description: string = '';
  lastEvaluatedKey: string = '';
  lastModified: IAtBy = new AtByModel('', '');
  name: string = '';
  scannedCount: number = 0;
  sendEdges: Array<IEchoEdge> = new Array<IEchoEdge>();
  sendMessageType: IMessageType = new MessageTypeModel();
  tenant: ITenant = new TenantModel();
  typeName: string = '';
  endpoint: string = '';
  token: string = '';
  stopped: boolean = false;

  public static create(
    name: string,
    description: string,
    typeName: string,
    sendEdges: Array<IEchoEdge>,
    endpoint: string,
    sendMessageType: IMessageType,
    token: string,
    stopped: boolean): FilesDotComWebhookNodeModel {
    const t = new FilesDotComWebhookNodeModel();
    t.name = name;
    t.description = description;
    t.sendEdges = sendEdges;
    t.sendMessageType = sendMessageType;
    t.typeName = typeName;
    t.endpoint = endpoint;
    t.token = token;
    t.stopped = stopped;
    return t;
  }

  async hydrate(data: any, tenant: ITenant): Promise<void> {
    //..
    // data.data.GetTenant.Deleted (true)
    console.log(data);

  }
}